import PaymentIconImage from "@/components/Images/PaymentIconImage";
import OnlyAndroid from "@/components/OnlyAndroid";
import TargetBlankLink from "@/components/TargetBlankLink";
import {
  useCampaignApplyingRange,
  useExtendedTrial,
  useModal,
  usePaymentInstrumentInfoQuery,
  useSubscriptionEstimateQuery,
  useSubscriptionEstimateWithCouponLazyQuery,
  useValuePlanTermsQuery,
} from "@/hooks";
import { PAYMENT_METHOD_ID, PAYMENT_METHOD_NAMES } from "@/lib/constants";
import dayjs from "@/lib/day";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
// TODO: CSSがめちゃくちゃなので直す
import { Button } from "@/components/Buttons";
import CalcTotalAmountModal from "@/components/CalcTotalAmountModal";
import CouponCodeForm from "@/components/Form/CouponCodeForm";
import {
  ErrorMessage,
  HiddenField,
  SingleCheckboxField,
} from "@/components/Form/Parts/index";
import Loading from "@/components/Loading";
import config from "@/lib/config";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";

export default function SubScriptionStep2({
  onSubmit,
  subscriptionData,
  paymentMethodId,
  paymentInstrumentId,
  error,
  onBack,
}) {
  const { course /*broadcastDiscount*/ } = subscriptionData;
  const { showModal } = useModal();
  const [unappliedCouponError, setUnppliedCouponError] = useState();
  const [applyCampaignCode, setApplyCampaignCode] = useState();
  const [applyVoucherCode, setApplyVoucherCode] = useState();

  // react-hook-form
  const schema = useMemo(() => {
    const schema = (() => {
      const defaultSchema = {
        couponCode: y.string(),
        // .length(0, "クーポンコードを適用するには適用ボタンを押してください"),
      };
      if (course.valuePlan) {
        return {
          ...defaultSchema,
          ...{
            valueplanTerm: y
              .boolean()
              .required("規約に同意してください。")
              .oneOf([true], "規約に同意してください。"),
            valuePlanTermKey: y.string(),
          },
        };
      } else {
        return defaultSchema;
      }
    })();
    return y.object().shape(schema);
  }, [course]);

  const { register, handleSubmit, formState, getValues, setValue, watch } =
    useForm({
      resolver: yupResolver(schema),
      mode: "all",
    });
  const { isValid, isSubmitting, errors } = formState;
  const watchCouponCode = watch("couponCode");

  // 支払い方法
  const { data, loading } = usePaymentInstrumentInfoQuery({
    variables: { id: paymentInstrumentId },
  });
  const paymentInstrument = data?.paymentInstrumentInfo || {};
  const paymentMethod = useMemo(() => {
    if (paymentInstrument) {
      return paymentInstrument.payment_method_id;
    }
  }, [paymentInstrument]);

  const paymentIconClassName = useMemo(() => {
    return paymentMethod === PAYMENT_METHOD_ID.CREDIT_CARD_3DS
      ? styles.paymentCreditCardImage
      : styles.paymentOtherImage;
  }, [paymentMethod]);

  const creditCardInfo = useMemo(() => {
    if (paymentInstrument) {
      return {
        type: paymentInstrument?.values?.card_type,
        number: `****-****-****-${paymentInstrument?.values?.card_number}`,
      };
    }
  }, [paymentInstrument]);

  // バリュープランの規約
  const { data: valuePlanTermsData } = useValuePlanTermsQuery();
  const valuePlanTerm = valuePlanTermsData?.terms?.[0];

  // 契約可能か確認
  const { data: estimateData, loading: estimateLoading } =
    useSubscriptionEstimateQuery({
      variables: { courseId: Number(course.id), paymentMethodId },
      onCompleted: ({ estimate }) => {
        if (estimate?.error) {
          // エラーの場合は前のページに戻す
          onBack(estimate.error);
        }
      },
    });
  const estimate = estimateData?.estimate;
  const coursePrice = formatPrice(course?.defaultPrice || 0); // 割引が適用されていない価格
  const trialFlag = estimate?.subscription?.status === "trial";
  const trialStartAt = trialFlag ? estimate?.subscription?.trialStartAt : null;
  const trialEndAt = trialFlag ? estimate?.subscription?.trialEndAt : null;

  // クーポン
  const [
    estimateWithCouponQuery,
    { data: estimateWithCouponData, loading: couponLoading },
  ] = useSubscriptionEstimateWithCouponLazyQuery({
    variables: { courseId: Number(course.id), paymentMethodId },
  });
  const estimateWithCoupon = estimateWithCouponData?.estimateWithCoupon;
  const campaignPrice =
    estimate?.campaignPrice || estimateWithCoupon?.campaignPrice;
  const appliedCamapign = !!estimate?.campaignPrice;
  const voucherCode = estimateWithCoupon?.voucherCode;

  // トライアル延長のバウチャーが適用された場合はトライアル終了日時を計算する
  // トライアルが延長された時は、初回決済日をフロント側で再計算する
  const [extendedTrialEndAt, initialTransactionAt] = useExtendedTrial(
    trialFlag,
    trialEndAt,
    estimate?.subscription?.initialTransactionAt,
    voucherCode
  );

  // トライアルがある場合は、キャンペーンの開始日時を再計算する
  // キャンペーン終了日時は、初回決済日からnヶ月後
  const [campaignStartAt, campaignEndAt] = useCampaignApplyingRange(
    campaignPrice?.campaign,
    initialTransactionAt,
    trialFlag,
    extendedTrialEndAt || trialEndAt
  );

  // // 放送契約割引キャンペーン
  // const broadcastDiscountCampaign = useMemo(() => {
  //   if (broadcastDiscount.result) {
  //     return estimate?.broadcastDiscountCampaignPrice?.campaign;
  //   }
  // }, [broadcastDiscount, estimate]);

  // // 放送契約割引の価格
  // const broadcastDiscountPrice = useMemo(() => {
  //   if (broadcastDiscount.result) {
  //     return formatPrice(
  //       estimate?.broadcastDiscountCampaignPrice.payment_amount
  //     );
  //   }
  // }, [broadcastDiscount, estimate]);

  // // 放送契約割引の適用開始日時
  // const broadcastDiscountStartAt = useMemo(() => {
  //   if (campaignEndAt) {
  //     return dayjs(new Date(campaignEndAt)).add(1, "day").format("YYYY/MM/DD");
  //   } else {
  //     return initialTransactionAt;
  //   }
  // }, [initialTransactionAt, broadcastDiscountCampaign, campaignEndAt]);

  // submitのコールバック
  const beforeSubmit = useCallback(
    (data) => {
      if (data.couponCode) {
        setUnppliedCouponError(
          "クーポンコード入力されていますが適用されていません。\n適用ボタンを押すか、入力をクリアしてから購入するボタンを押してください。"
        );
      } else {
        onSubmit({ ...data, ...{ applyCampaignCode, applyVoucherCode } });
      }
    },
    [onSubmit, applyCampaignCode, applyVoucherCode]
  );

  // 前のページに戻る
  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    }
  }, [onBack]);

  // クーポン適用
  const applyCoupon = useCallback(() => {
    const couponCode = getValues("couponCode");
    estimateWithCouponQuery({
      variables: {
        courseId: Number(course.id),
        paymentMethodId: paymentMethod,
        couponCode,
      },
    });
  }, [paymentMethod]);

  // クーポンの適用キャンセル
  const handleCouponCancel = useCallback(() => {
    estimateWithCouponQuery({
      variables: {
        courseId: Number(course.id),
        paymentMethodId: paymentMethod,
        couponCode: null,
      },
    });
  }, [paymentMethod]);

  // 年額計算のモーダルをオープン
  const handleCalcTotalAmount = useCallback(() => {
    showModal(
      <CalcTotalAmountModal
        initialTransactionAt={initialTransactionAt}
        pricings={estimate?.coursePricings}
        //broadcastDiscountCampaign={broadcastDiscountCampaign}
        applyCamapign={campaignPrice?.campaign}
      />,
      {
        style: "dialogue",
      }
    );
  }, [
    estimate,
    initialTransactionAt,
    //broadcastDiscountCampaign,
    campaignPrice,
  ]);

  // クーポンコードのフォームが空になったら購入ボタン上のエラーメッセージをリセット
  useEffect(() => {
    if (unappliedCouponError && !watchCouponCode) {
      setUnppliedCouponError("");
    }
  }, [unappliedCouponError, watchCouponCode]);

  // クーポンが適応後にクーポン入力を非表示にする
  useEffect(() => {
    if (estimateWithCouponData) {
      const estimateWithCoupon = estimateWithCouponData.estimateWithCoupon;

      const apply = { campaignCode: null, voucherCode: null };

      if (!estimateWithCoupon?.error) {
        const couponCode = getValues("couponCode");

        if (estimateWithCoupon?.campaignPrice) {
          apply.campaignCode = couponCode;
        } else if (estimateWithCoupon?.voucherCode) {
          apply.voucherCode = couponCode;
        }
      }

      setApplyCampaignCode(apply.campaignCode);
      setApplyVoucherCode(apply.voucherCode);

      // Reset du champ couponCode du formulaire
      setValue("couponCode", "", { shouldValidate: true });
    }
  }, [estimateWithCouponData, getValues, setValue]);

  if (loading || estimateLoading) return null;
  if (!estimate?.subscription) return null;

  return (
    <>
      {couponLoading && <Loading fixed />}
      {course.valuePlan && (
        <OnlyAndroid version={7}>
          <div className={styles.cautionSection}>
            <div className={styles.text}>
              <p>
                この商品はご利用の端末（Android7以下）ではご視聴いただけません。
                <br />
                ご視聴にはAndroid8以降の端末またはPC、iOS、アプリ対応テレビが必要になりますので
                ご注意ください。
                <br />
                詳しくは
                <TargetBlankLink
                  href={routes.environment}
                  className={styles.link}
                >
                  動作環境
                </TargetBlankLink>
                をご確認ください。
              </p>
            </div>
          </div>
        </OnlyAndroid>
      )}
      <div className={processStyles.contentWrapper}>
        <div className={`${processStyles.content} ${styles.container}`}>
          <p className={processStyles.contentHeader}>
            下記の内容で購入しますか？
          </p>
          <div className={styles.container}>
            <div
              className={`${styles.section} ${styles.column} ${styles.courseInfo}`}
            >
              <div className={styles.table}>
                <div className={styles.row}>
                  <div className={styles.label}>商品名</div>
                  <div className={styles.value}>{course.name}</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.label}>金額</div>
                  <div className={styles.value}>
                    <span className={styles.priceAmount}>
                      <span>月額</span> {coursePrice}円<span>（税込）</span>
                    </span>
                  </div>
                </div>
                <div className={styles.row}>
                  <div className={styles.label}>支払方法</div>
                  <div className={styles.value}>
                    <div>{PAYMENT_METHOD_NAMES[paymentMethod]}</div>
                    {(paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_3DS ||
                      paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS) && (
                      <div>
                        <PaymentIconImage
                          paymentMethodId={paymentMethod}
                          cardType={creditCardInfo.type}
                          className={paymentIconClassName}
                        />
                        <span>{creditCardInfo.number}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.row}>
                  <div className={styles.label}>初回決済日</div>
                  <div className={styles.value}>{initialTransactionAt}</div>
                </div>
              </div>
              <ul className={styles.attentionNote}>
                <li>※ 以降毎月同日に決済となります。</li>
                <li>
                  ※
                  29日、30日、31日にご購入の場合は翌月末が決済日となる場合がございます。
                </li>
                <li>
                  ※
                  引き落とし日は各クレジットカード会社、決済サービスごとに異なります。
                </li>
              </ul>
            </div>
            {trialFlag && (
              <div
                className={`${styles.section} ${styles.column} ${styles.trialInfo}`}
              >
                <div className={styles.header}>{course.trialText}</div>
                <div className={styles.table}>
                  <div className={styles.row}>
                    <div className={styles.label}>適用期間</div>
                    <div className={styles.value}>
                      {trialStartAt} 〜 {!extendedTrialEndAt && trialEndAt}
                      {extendedTrialEndAt && (
                        <span>
                          <span className={styles.lineThrough}>
                            {trialEndAt}
                          </span>{" "}
                          {extendedTrialEndAt}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.label}>金額</div>
                    <div className={styles.value}>
                      無料（
                      {course.trialCampaignFlag
                        ? course.trialText
                        : "トライアル"}
                      ）
                    </div>
                  </div>
                </div>
                {extendedTrialEndAt && (
                  <div>
                    <a
                      className={styles.couponCancelLink}
                      onClick={handleCouponCancel}
                    >
                      トライアル延長の適用を解除する
                    </a>
                  </div>
                )}
              </div>
            )}

            {campaignPrice && (
              <div className={`${styles.section} ${styles.column}`}>
                {trialFlag && (
                  <div>
                    {course.trialCampaignFlag ? "キャンペーン" : "トライアル"}
                    期間終了後
                  </div>
                )}
                <div className={styles.header}>
                  {campaignPrice.campaign.name}
                </div>
                <div className={styles.table}>
                  <div className={styles.row}>
                    <div className={styles.label}>適用期間</div>
                    <div className={styles.value}>
                      {campaignStartAt} 〜 {campaignEndAt}
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.label}>金額</div>
                    <div className={styles.value}>
                      <span className={styles.priceAmount}>
                        <span>月額</span>{" "}
                        {formatPrice(campaignPrice.payment_amount)}円
                        <span>（税込）</span>
                      </span>
                    </div>
                  </div>
                </div>
                {!appliedCamapign && (
                  <div>
                    <a
                      className={styles.couponCancelLink}
                      onClick={handleCouponCancel}
                    >
                      キャンペーンの適用を解除する
                    </a>
                  </div>
                )}
              </div>
            )}
            {/*broadcastDiscountCampaign && (
              <div className={`${styles.section} ${styles.column}`}>
                {trialFlag && !campaignPrice && (
                  <div>
                    {course.trialCampaignFlag ? "キャンペーン" : "トライアル"}
                    期間終了後
                  </div>
                )}
                <div className={styles.header}>
                  {broadcastDiscountCampaign.name}
                </div>
                <div className={styles.table}>
                  <div className={styles.row}>
                    <div className={styles.label}>適用期間</div>
                    <div className={styles.value}>
                      {broadcastDiscountStartAt} 〜{" "}
                      {broadcastDiscountCampaign.validityEndAt}
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.label}>金額</div>
                    <div className={styles.value}>
                      <span className={styles.priceAmount}>
                        <span>月額 </span>
                        {broadcastDiscountPrice}円<span>（税込）</span>
                      </span>
                    </div>
                  </div>
                </div>
                <ul className={styles.attentionNote}>
                  <li>
                    ※ 放送契約者割引適用終了後から、通常金額（月額
                    {coursePrice}
                    円（税込））になります。
                  </li>
                  <li>
                    ※
                    放送契約者割引の対象放送商品が解約された場合には、対象放送商品が解約された月の翌月から、通常金額（月額
                    {coursePrice}円（税込））になります。
                  </li>
                  <li>
                    ※ 詳しくは
                    <span className={styles.discountLink}>
                      <TargetBlankLink
                        href={routes.campaignWithBroadcast}
                        className={styles.link}
                      >
                        こちら
                      </TargetBlankLink>
                    </span>
                  </li>
                </ul>
              </div>
            )*/}
          </div>

          <ul className={styles.attentionNote}>
            <li>
              契約期間中は、商品に内包されるコンテンツを視聴することができます。
            </li>
            {/*campaignPrice && broadcastDiscountCampaign && (
              <li>
                適用可能なキャンペーンやクーポンが複数ある場合は、同一期間内での割引金額の大きいキャンペーンから順に適用され、同一期間の重複利用はできません。又、割引適用前にご解約の場合も上記キャンペーン・クーポンの返却はできません。
              </li>
            )*/}
            {trialFlag && (
              <li>
                {course.trialText}
                期間終了後は、ご解約いただくまでは商品の販売終了日まで1ヶ月ごとに自動的に更新されます。
              </li>
            )}
            <li>
              1年ご契約継続時の総額は
              <a
                className={styles.accentColoelink}
                onClick={handleCalcTotalAmount}
              >
                こちら
              </a>
            </li>
          </ul>
        </div>
      </div>
      {error && (
        <div className={styles.creditCardError}>
          <ErrorMessage msg={error} />
        </div>
      )}
      <CouponCodeForm
        enable={!applyCampaignCode && !applyVoucherCode}
        register={register}
        apply={applyCoupon}
        error={estimateWithCoupon?.error || errors?.couponCode?.message}
      />
      <div className={formStyles.guideArea}>
        <p>
          解約について
          <br />
          月額商品の解約は、契約期間の満了する24時間前までに
          アカウントページ＞ご利用状況 からお手続きください。
          <br />
          商品の性質上、決済完了後のキャンセルや返金等には応じられません。
        </p>
        {trialFlag && (
          <p>
            {course.trialText}期間中に解約された場合、{course.trialText}
            期間が残っていても即日ご視聴いただけなくなります。
          </p>
        )}
      </div>
      <form onSubmit={handleSubmit(beforeSubmit)} noValidate>
        {course.valuePlan && valuePlanTerm && (
          <div className={formStyles.guideArea}>
            <SingleCheckboxField
              {...register("valueplanTerm")}
              title="この商品の購入には規約の同意が必要です。"
              defaultChecked={false}
              label={
                <p className={formStyles.terms}>
                  <TargetBlankLink href={valuePlanTerm.current_revision.url}>
                    {valuePlanTerm.display_name}
                  </TargetBlankLink>
                  に同意する
                </p>
              }
              error={errors?.valueplanTerm?.message}
            />
            <HiddenField
              {...register("valuePlanTermKey")}
              value={valuePlanTerm.current_revision.unique_key}
            />
            <p className={formStyles.caption}>
              『{config.valuePlan.text}
              』ご利用者様の個人情報は、株式会社NTTドコモとスカパーJSAT株式会社で共同利用させていただきます。詳しくは
              <TargetBlankLink
                href="/static/legal/valueplan_sharing_item"
                className={formStyles.textLink}
              >
                こちら
              </TargetBlankLink>
              をご確認下さい。
            </p>
          </div>
        )}
        <div className={formStyles.btnArea}>
          <ErrorMessage msg={unappliedCouponError} />
          <Button
            type="submit"
            fillColor
            fontFixed
            large
            disabled={!isValid}
            loading={isSubmitting}
          >
            {course.valuePlan && trialFlag && (
              <>{course.trialTermText}を利用して</>
            )}
            購入する
          </Button>
          <div className={styles.backButton}>
            <a onClick={handleBack}>前の画面へ戻る</a>
          </div>
        </div>
      </form>
    </>
  );
}
